<script lang="ts">
export default {
  inheritAttrs: false,
  customOptions: {},
}
</script>

<script lang="ts" setup>
// components logic here
import { getContrastColor } from '@/utils/colorScale'

const props = defineProps(['onBack', 'color'])
</script>

<template>
  <slot>
    <van-row
      align="center"
      justify="space-around"
      class="header"
      :style="{ backgroundColor: props.color }"
    >
      <slot name="left">
        <van-col span="11">
          <slot name="left-icon">
            <van-icon
              style="margin-left: 10px"
              name="arrow-left"
              size="25"
              @click="props.onBack()"
              :style="{ color: getContrastColor(props.color) }"
            />
          </slot>
        </van-col>
      </slot>

      <slot name="right">
        <van-col style="margin-right: 10px" span="11"></van-col>
      </slot>
    </van-row>
  </slot>
</template>

<style scoped>
.fake-header {
  height: 50px;
  padding: 15px;
}
.header {
  position: fixed;
  top: 0;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: #dddddd;
  justify-content: space-between;
}
</style>
